import { ColumnsType } from "antd/es/table";
import { Button, Switch, Tooltip } from "antd";
import { GlobalButton } from "../../comman/GlobalButton.styles";
import { InputSwitch } from "primereact/inputswitch";
import { getFlagFromAlpha3 } from "../../../utils/getFlags";

export interface PartnerListData {
	key: number;
	individualName: string;
	businessName: string;
	role: string;
	status: string;
	profileId: string;
	userId: string;
	stepCompleted: number;
	loginEmail?: string;
	businessEmail?: string;
	isFreelancer?: boolean;
	receiveCurrency?: string;
	receiveCountryCode?: string;
}

interface ColumnsConfigProps {
	onView: (key: string) => void;
	onApprove: (key: string) => void;
}

const ColumnsConfig = ({ onView, onApprove }: ColumnsConfigProps): ColumnsType<PartnerListData> => [
	{
		title: "Business Name",
		dataIndex: "businessName",
		key: "businessName",
		sorter: (a, b) => a.businessName.localeCompare(b.businessName),
		render: (text, record) => ( 
			<div style={{ display: "flex", flexDirection: "column" }}>
				<span> {record.isFreelancer? record.individualName:""} {text}</span>
				<span style={{ fontSize: "12px", color: "#0000006e" }}>{record.isFreelancer?"Freelancer":"Business"}</span>
			</div>
		)
	},
	{
		title: "Login Email",
		dataIndex: "loginEmail",
		key: "loginEmail",
		sorter: (a, b) => a.loginEmail?.localeCompare(b.loginEmail)
	},
	{
		title: "Business Email",
		dataIndex: "businessEmail",
		key: "businessEmail",
		sorter: (a, b) => a.businessEmail?.localeCompare(b.businessEmail)
	},
	{
		title: "User Country / Currency",
		dataIndex: "receiveCurrency",
		key: "receiveCurrency",
		width: 140,
		align: "left",
		render: (text, record) => (
			<div
				style={{
					color: "var(--purple-light)",
					fontSize: "13px"
				}}
			>
				{record.receiveCountryCode && (
					<span style={{ display: "flex", alignItems: "center", marginRight: "4px" }}>
						<img
							src={getFlagFromAlpha3(record.receiveCountryCode)}
							alt={record.receiveCountryCode}
							style={{
								width: "15px",
								height: "15px",
								borderRadius: "50%",
								marginRight: "4px",
								objectFit: "cover"
							}}
							/>
						{`${record.receiveCountryCode} /`}
						{text}
					</span>
				)}
			</div>
		)
	},
	{
		title: "Onboarding Status",
		dataIndex: "status",
		key: "status",
		sorter: (a, b) => a.status.localeCompare(b.status)
	},
	{
		title: "Step Completed",
		dataIndex: "stepCompleted",
		key: "stepCompleted",
		width: 100,
		sorter: (a, b) => a.stepCompleted - b.stepCompleted
	},
	{
		title: "View",
		key: "view",
		fixed: "right",
		align: "center",
		render: (_, record) => (
			<div className="d-flex justify-content-center">
				<GlobalButton className="primary" onClick={() => onView(record.userId)}>
					View
				</GlobalButton>
			</div>
		)
	},
	{
		title: "Action",
		key: "approve",
		fixed: "right",
		align: "center",
		render: (_, record) => {
			const isDisabled = record.stepCompleted !== 3;

			const buttonClass = !isDisabled ? (record.status?.toLowerCase() === "approved" ? "approved" : "primary") : "";
			return (
				<div className="d-flex justify-content-center">
					<Tooltip
						title={
							isDisabled ? "All required steps must be completed before approval." : "Click to review and take action on this profile."
						}
					>
						<GlobalButton className={buttonClass} onClick={() => onApprove(record.profileId)} disabled={isDisabled}>
							Approve
						</GlobalButton>
					</Tooltip>
				</div>
			);
		}
	}
];

export default ColumnsConfig;
